import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { GetFormMasterFieldsValuesComponent } from '../../../../../DynamicFormsModule/formsValues/components/get.fields/get.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-follow-request',
  templateUrl: './follow-request.component.html',
  styleUrls: ['./follow-request.component.scss'],
})
export class FollowRequestComponent implements OnInit {
  item: any[];
  complete: boolean;
  formId: number;
  requestId: number;
  constructor(protected ref: NbDialogRef<FollowRequestComponent>, private dialogService: NbDialogService) {}

  ngOnInit() {}
  close() {
    this.ref.close();
  }

  formDetail(id, formId) {
    const initialState = {
      refId: id,
      formId: formId,
      refDataType: 'Phase',
    };
    this.dialogService.open(GetFormMasterFieldsValuesComponent, {
      context: { refId: id, formId: formId, refDataType: 'Phase'},
    });
  }
}
